import {
    DontIncludeMostRecentAttachments,
    IncludeMostRecentAttachmentAddedRecipient_MultipleRecipientsText,
    IncludeMostRecentAttachmentAddedRecipient_SingleRecipientText,
    SuggestIncludeMostRecentAttachment_MultipleAttachmentsText,
    SuggestIncludeMostRecentAttachment_SingleAttachmentText,
} from './includeMostRecentAttachmentsInfoBarMessage.locstring.json';
import loc, { format } from 'owa-localize';
import createAttachmentsFromRecentAttachments from './AttachmentQueueManager/createAttachmentsFromRecentAttachments';
import AttachmentWellViewState from '../schema/AttachmentWellViewState';
import { logUsage } from 'owa-analytics';
import { ClientItemId } from 'owa-client-ids';
import { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';
import Message from 'owa-service/lib/contract/Message';
import addInfoBarMessage from 'owa-info-bar/lib/actions/addInfoBarMessage';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';

import {
    InfoBarMessageViewState,
    InfoBarCustomAction,
    InfoBarMessageSource,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export const INCLUDE_MOST_RECENT_ATTACHMENTS_MESSAGEID: string =
    'InfoIncludeMostRecentAttachmentsMessage';

export interface RecipientsCollection {
    toRecipients: ReadWriteRecipientViewState[];
    ccRecipients: ReadWriteRecipientViewState[];
    bccRecipients: ReadWriteRecipientViewState[];
}

export function includeMostRecentAttachmentsInfoBarMessage(
    itemId: ClientItemId,
    message: Message,
    attachmentWell: AttachmentWellViewState,
    recipientNameAdded: string,
    numberOfAddedRecipients: number,
    infoBar: InfoBarHostViewState,
    updateActedComposeCallback: () => void,
    filterAttachmentsBasedOnAttachmentPolicy: (attachment) => boolean
) {
    const attatchmentsMessageString = getAddedRecipientAttachmentsInfoBarString(
        numberOfAddedRecipients,
        recipientNameAdded
    );
    const infoBarMessageViewState: InfoBarMessageViewState = {
        key: INCLUDE_MOST_RECENT_ATTACHMENTS_MESSAGEID,
        source: InfoBarMessageSource.Compose,
        rank: null,
        message: attatchmentsMessageString,
        messageParts: [attatchmentsMessageString],
    };

    infoBarMessageViewState.messageParts.push(
        getIncludeMostRecentAttachmentsInfoBarAction(
            itemId,
            attachmentWell,
            message,
            infoBar,
            updateActedComposeCallback,
            filterAttachmentsBasedOnAttachmentPolicy
        )
    );
    infoBarMessageViewState.messageParts.push('|');
    infoBarMessageViewState.messageParts.push(
        getDoNotIncludeMostRecentAttachmentsInfoBarAction(infoBar, updateActedComposeCallback)
    );

    addInfoBarMessage(
        infoBar,
        INCLUDE_MOST_RECENT_ATTACHMENTS_MESSAGEID,
        () => infoBarMessageViewState
    );
}

function getDoNotIncludeMostRecentAttachmentsInfoBarAction(
    infoBar: InfoBarHostViewState,
    updateActedComposeCallback: () => void
): InfoBarCustomAction {
    return {
        text: loc(DontIncludeMostRecentAttachments),
        action: () => {
            updateActedComposeCallback();
            removeInfoBarMessage(infoBar, [INCLUDE_MOST_RECENT_ATTACHMENTS_MESSAGEID]);
            logUsage('AttachmentDoNotIncludeMostRecentAttachments');
        },
    };
}

function getAddedRecipientAttachmentsInfoBarString(
    numberOfAddedRecipients: number,
    recipientNameAdded: string
): string {
    const recipientAddedNotificatioMessage: string =
        numberOfAddedRecipients > 1
            ? format(
                  loc(IncludeMostRecentAttachmentAddedRecipient_MultipleRecipientsText),
                  numberOfAddedRecipients
              )
            : format(
                  loc(IncludeMostRecentAttachmentAddedRecipient_SingleRecipientText),
                  recipientNameAdded
              );

    return recipientAddedNotificatioMessage;
}

function getIncludeMostRecentAttachmentsInfoBarAction(
    itemId: ClientItemId,
    attachmentWell: AttachmentWellViewState,
    message: Message,
    infoBar: InfoBarHostViewState,
    updateActedComposeCallback: () => void,
    filterAttachmentsBasedOnAttachmentPolicy: (attachment) => boolean
): InfoBarCustomAction {
    const includeMostRecentAttachmentMessage: string =
        message.Attachments.length > 1
            ? loc(SuggestIncludeMostRecentAttachment_MultipleAttachmentsText)
            : loc(SuggestIncludeMostRecentAttachment_SingleAttachmentText);

    return {
        text: includeMostRecentAttachmentMessage,
        action: () => {
            updateActedComposeCallback();
            logUsage('AttachmentIncludeMostRecentAttachments');
            createAttachmentsFromRecentAttachments(
                itemId,
                attachmentWell,
                message.Attachments.filter(attachment =>
                    filterAttachmentsBasedOnAttachmentPolicy(attachment)
                ),
                infoBar
            );
        },
    };
}
